import { useMediaQuery } from 'react-responsive'

const useIsMobile = () => {
  // "md" size in media-query.json
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  return isMobile;
}

export default useIsMobile;